// extracted by mini-css-extract-plugin
export default {"trendsGraphContainer":"TrendsGraph_trendsGraphContainer__ubJ9c"};